import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { METHOD_LABEL } from "@/components/wallet/shared";

export default function WalletConfigDialog({ open, onOpenChange }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["wallet-config"], queryFn: async () => (await api.get("/wallet/config")).data, enabled: open });
  const [text, setText] = useState("");
  const [methods, setMethods] = useState([]);
  useEffect(() => { if (data) { setText(data.payment_instructions || ""); setMethods(data.enabled_methods || []); } }, [data]);
  const save = useMutation({
    mutationFn: async () => (await api.put("/wallet/config", { payment_instructions: text, enabled_methods: methods })).data,
    onSuccess: () => { toast.success("Impostazioni wallet salvate"); qc.invalidateQueries({ queryKey: ["wallet-config"] }); onOpenChange(false); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });
  const toggle = (k) => setMethods(methods.includes(k) ? methods.filter((m) => m !== k) : [...methods, k]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Impostazioni wallet</DialogTitle></DialogHeader>
        <div>
          <Label className="text-xs">Metodi di pagamento accettati per le ricariche</Label>
          <div className="flex gap-1.5 flex-wrap mt-1.5" data-testid="wallet-config-methods">
            {Object.entries(METHOD_LABEL).map(([k, l]) => (
              <button key={k} type="button" onClick={() => toggle(k)} data-testid={`wallet-config-method-${k}`}
                className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${methods.includes(k) ? "bg-[#0F766E] text-white border-[#0F766E]" : "bg-white border-stone-200 text-stone-500"}`}>{l}</button>
            ))}
          </div>
          <p className="text-[11px] text-stone-500 mt-1">Solo questi metodi compaiono a studenti e docenti quando richiedono una ricarica e nelle ricariche registrate dall'economato.</p>
        </div>
        <div>
          <Label className="text-xs">Istruzioni di pagamento</Label>
          <p className="text-xs text-stone-500">Mostrate a studenti e docenti quando richiedono una ricarica (IBAN, indirizzo PayPal, orari cassa…).</p>
          <Textarea rows={6} value={text} onChange={(e) => setText(e.target.value)} className="mt-1.5" placeholder={"Contanti: in segreteria, lun–ven 9:00–12:00"} data-testid="wallet-config-text"/>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button className="bg-[#0F766E] hover:bg-[#115E59]" onClick={() => save.mutate()} disabled={save.isPending || !methods.length} data-testid="wallet-config-save">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
